import { render } from "./BurgerNavigation.vue?vue&type=template&id=4084771c"
import script from "./BurgerNavigation.vue?vue&type=script&lang=js"
export * from "./BurgerNavigation.vue?vue&type=script&lang=js"

import "./BurgerNavigation.vue?vue&type=style&index=0&id=4084771c&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__